// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-top-divider[data-v-4a2838aa]{top:32px;height:1px}@media only screen and (max-width:768px){.table-top-divider[data-v-4a2838aa]{display:none}}.product-image-preview[data-v-4a2838aa]{width:80px}th[data-v-4a2838aa]{font-weight:400;text-align:left}.cart-desktop-width[data-v-4a2838aa]{max-width:1024px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
